import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import styles from './Appointments.module.scss';
import { Icon } from '../../ui/components/Icon/Icon';
import { Button } from '../../ui/components/Button/Button';
import { Heading } from '../../ui/components/Heading/Heading';
import { InitialContext } from '../Layout/Layout';
import { TodayAppointments } from './_components/TodayAppointments/TodayAppointments';
import { NextAppointment } from './_components/NextAppointment/NextAppointment';
import { useGQLLazyQuery } from '../../ui/utils/graphql';
import { GET_ALL_APPOINTMENTS_OF_A_DAY } from '../../graphql/Appointments';
import { Appointment, AppointmentStatus } from '../../gql/graphql';
import { toLocalISOString } from '../../ui/utils/Date';
import { appointmentTimeWithTimeOffset } from '../_utils/AppointmentUtils';

export const Appointments = () => {
  const [nextAppointment, setNextAppointment] = useState<Appointment | null>(
    null
  );
  const navigate = useNavigate();
  const { company } = useContext(InitialContext);

  const { lazy, data: appointments } = useGQLLazyQuery<
    Appointment[],
    { companyId: string; day: string; range: string }
  >(GET_ALL_APPOINTMENTS_OF_A_DAY, {
    onCompleted: (data) => {
      console.log(data);
    },
  });

  useEffect(() => {
    if (appointments && appointments.length > 0 && company) {
      const nextLocalAppointment = appointments.filter(
        (apt) =>
          apt.status === AppointmentStatus.Confirmed ||
          apt.status === AppointmentStatus.Pending ||
          apt.status === AppointmentStatus.Rescheduled ||
          apt.status === AppointmentStatus.Created
      )[0];
      const appointmentTime = appointmentTimeWithTimeOffset(
        nextLocalAppointment?.dayOfAppointment,
        nextLocalAppointment?.Company?.timeZone
      ).getTime();
      setNextAppointment(nextLocalAppointment);
      const now = new Date().getTime();
      const timeUntilNextAppointment = appointmentTime - now;

      if (timeUntilNextAppointment > 0) {
        const timeout = setTimeout(() => {
          lazy({
            variables: {
              companyId: company?.id,
              day: toLocalISOString(new Date()).split('T')[0],
              range: 'ALL',
            },
            fetchPolicy: 'network-only',
          });
        }, timeUntilNextAppointment);

        return () => clearTimeout(timeout);
      }
    }

    return () => {};
  }, [appointments, company]);

  useEffect(() => {
    if (company) {
      lazy({
        variables: {
          companyId: company?.id,
          day: toLocalISOString(new Date()).split('T')[0],
          range: 'ALL',
        },
        fetchPolicy: 'no-cache',
      });
    }
  }, [company]);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Heading className={styles.heading} headingLevel="h1">
          {`Consultas de ${company?.name}`}
        </Heading>
      </div>
      <div className={styles.buttons}>
        <Button
          btnStyle="primary"
          onClick={() => navigate('/appointments/new-appointment')}
          className={styles.button}
        >
          <Icon type="calendar" />
          <div>Añadir cita</div>
        </Button>
        <Button
          btnStyle="primary"
          onClick={() => navigate('/appointments/history')}
          className={styles.button}
        >
          <Icon type="eye" />
          <div>Ver historial</div>
        </Button>
      </div>
      <NextAppointment appointment={nextAppointment} />
      <TodayAppointments appointments={appointments} />
    </div>
  );
};
